import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminRobots from "@/pages/admin/AdminRobots";
import AdminOutreach from "@/pages/admin/AdminOutreach";
import AdminSponsors from "@/pages/admin/AdminSponsors";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminMedia from "@/pages/admin/AdminMedia";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#0a0a0a",
                border: "1px solid rgba(30,63,216,0.5)",
                color: "#fff",
                borderRadius: 0,
                fontFamily: '"Exo 2", sans-serif',
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminOverview />} />
              <Route path="team" element={<AdminTeam />} />
              <Route path="robots" element={<AdminRobots />} />
              <Route path="outreach" element={<AdminOutreach />} />
              <Route path="sponsors" element={<AdminSponsors />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="media" element={<AdminMedia />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
